(function(){
    if (window.__pq) return; window.__pq = 1;
    var RIOTS = '#the-public-riots';
    /* the headline is set as large as it can be while staying on three lines, so it fills the drawer's width on any screen */
    var lastW = 0;
    function fitHead(){
      var h = document.querySelector('.pq__head');
      if (!h || !h.clientWidth || h.clientWidth === lastW) return;
      lastW = h.clientWidth;
      /* sized as if every word could break; the words held together are checked after */
      var keep = h.innerHTML; h.textContent = h.textContent.replace(/\u00a0/g, ' ');
      var lo = 16, hi = 240;
      for (var i = 0; i < 16; i++) {
        var m = (lo + hi) / 2; h.style.fontSize = m + 'px';
        var lh = parseFloat(getComputedStyle(h).lineHeight) || m * 1.04;
        if (h.scrollWidth > h.clientWidth + 1 || Math.round(h.scrollHeight / lh) > 3) hi = m; else lo = m;
      }
      /* Customize > Theme settings > The ? menu > Headline size: 100% fills the width, less leaves air on the right */
      var k = Math.min(100, Math.max(40, parseFloat(h.getAttribute('data-scale')) || 50)) / 100;
      var fs = Math.floor(lo * k * 10) / 10; h.innerHTML = keep; h.style.fontSize = fs + 'px';
      /* "Recycling brand". stays on one line: if it does not fit, the headline steps down just enough */
      while (fs > 16 && h.scrollWidth > h.clientWidth + 1) { fs -= .5; h.style.fontSize = fs + 'px'; }
    }
    function watch(){
      var pq = document.querySelector('.pq');
      if (!pq) return;
      if (window.ResizeObserver) new ResizeObserver(function(){ requestAnimationFrame(fitHead); }).observe(pq);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ lastW = 0; fitHead(); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    function closeDrawer(el){
      /* close it exactly as the cross does, through the theme's own drawer */
      var hd = el.closest('header-drawer'), sm = hd && hd.querySelector('details[open] > summary');
      if (sm) sm.click();
    }
    /* the newspaper opens the same way a tap on its object does */
    function openRiots(){
      var o = document.querySelector('.pw__object[data-opens="newspaper"]');
      if (!o) return false;
      var r = o.getBoundingClientRect(), x = r.left + r.width / 2, y = r.top + r.height / 2, o2 = {bubbles: true, cancelable: true, clientX: x, clientY: y, pointerType: 'mouse', isPrimary: true, button: 0};
      try { o.dispatchEvent(new PointerEvent('pointerdown', o2)); o.dispatchEvent(new PointerEvent('pointerup', o2)); } catch (e) {}
      o.dispatchEvent(new MouseEvent('click', o2));
      return true;
    }
    /* a search result inside the world opens in its window instead of leaving for a plain page:
       a project opens on its plot in Parade 03:, a piece opens its look in Parade 01:, a dinner, recipe or chef opens in Parade 02:, a riot opens the newspaper */
    document.addEventListener('click', function(e){
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      var a = e.target.closest && e.target.closest('#predictive-search-results a[href]');
      if (!a) return;
      var u; try { u = new URL(a.href, location.href); } catch (x) { return; }
      var p = u.pathname, m, go = null;
      /* inside the world the window opens in place; from any other page (the cart) the world opens with that window */
      function toWorld(v){
        if (window.PA) { window.PA.set(v); return; }
        var k = /^#(parade-0\d)(?:\/(.*))?$/.exec(v);
        if (k) location.assign('/pages/' + k[1] + (k[2] ? '#' + k[2] : ''));
      }
      if (/^\/blogs\/(neo-traditional-syncretism|biophilic-futurism|surrealist-architecture)\//.test(p)) go = function(){ var ad = a.getAttribute('data-pq-addr'); toWorld('#parade-03' + (ad && /^[a-z]{3}\/[A-D][1-4]-\d+$/.test(ad) ? '/' + ad : '')); };
      else if ((m = /^\/products\/([^\/]+)/.exec(p))) go = function(){ toWorld('#parade-01/' + m[1]); };
      else if ((m = /^\/blogs\/(chefs|supper-parade|recipes)\/([^\/]+)/.exec(p))) go = function(){ toWorld('#parade-02/' + m[2]); };
      else if (/^\/blogs\/the-public-riots(\/|$)/.test(p)) go = function(){ if (!window.PA) { location.assign('/' + RIOTS); return; } if (/^#parade-0/.test(window.PA.h())) window.PA.set(''); setTimeout(openRiots, 350); };
      else if ((m = /^\/pages\/(parade-0[1-3])\/?$/.exec(p))) go = function(){ toWorld('#' + m[1]); };
      if (!go) return;
      e.preventDefault(); e.stopPropagation();
      var dm = a.closest('details-modal');
      if (dm && dm.close) dm.close(false); else { var d = document.querySelector('details-modal details[open]'); if (d) d.removeAttribute('open'); }
      setTimeout(go, 150);
    }, true);
    /* pressing Enter in the search opens the first result rather than Shopify's plain results page */
    document.addEventListener('submit', function(e){
      var f = e.target;
      if (!f || !f.closest || !f.closest('.search-modal')) return;
      e.preventDefault();
      var first = f.closest('.search-modal').querySelector('#predictive-search-results a[href]');
      if (first) first.click();
    }, true);
    /* opening the search closes the ? drawer, so only one panel is ever open */
    document.addEventListener('click', function(e){
      if (!e.target.closest || !e.target.closest('.header__icon--search')) return;
      var dsm = document.querySelector('header-drawer details[open] > summary');
      if (dsm) dsm.click();
    }, true);
    function riotsLink(a){ var h = a.getAttribute('href') || ''; return h.slice(-RIOTS.length) === RIOTS; }
    document.addEventListener('click', function(e){
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      var a = e.target.closest && e.target.closest('.pq a');
      if (!a || !window.PA) return;
      if (a.classList.contains('pq__item')) {
        e.preventDefault(); closeDrawer(a);
        setTimeout(function(){ window.PA.set('#' + a.getAttribute('data-pq')); }, 200);
      } else if (riotsLink(a)) {
        e.preventDefault(); closeDrawer(a);
        /* a Parade window in front closes first, so the newspaper is not hidden behind it */
        if (/^#parade-0/.test(window.PA.h())) window.PA.set('');
        setTimeout(openRiots, 350);
      }
    });
    /* parade.house/#the-public-riots (the link's address outside the world) opens the newspaper on arrival */
    if (location.hash === RIOTS) {
      window.addEventListener('load', function(){
        setTimeout(function(){
          if (openRiots()) history.replaceState(history.state, '', location.pathname + location.search);
        }, 900);
      });
    }
  /* Oct 30: pinching or ctrl + wheel never zooms the page while the menu or the search is open, or on them (phone, tablet and desktop) */
    function pqUI(t){
      if (document.querySelector('#Details-menu-drawer-container[open], details-modal.header__search details[open], .search-modal[open], details[open] > .search-modal')) return true;
      return !!(t && t.closest && t.closest('#menu-drawer, .search-modal'));
    }
    document.addEventListener('touchmove', function(e){ if (e.touches.length > 1 && pqUI(e.target)) e.preventDefault(); }, {passive: false, capture: true});
    ['gesturestart', 'gesturechange', 'gestureend'].forEach(function(n){
      document.addEventListener(n, function(e){ if (pqUI(e.target)) e.preventDefault(); }, {passive: false, capture: true});
    });
    document.addEventListener('wheel', function(e){ if (e.ctrlKey && pqUI(e.target)) e.preventDefault(); }, {passive: false, capture: true});
  })();
